/**
 * Chuỗi của tab Giá vốn model (màn Gói & thanh toán) ở cổng nền tảng (giá vốn, tỷ giá, ADR-0123 mục 4) — tách
 * tệp khi dựng song song, sẽ gộp vào `vi.ts`. Khoá cấp một mang tiền tố `giaAi`; sâu tối đa hai cấp dưới nó.
 *
 * Câu chữ lấy từ màn Cấu hình của native (`apps/web-portal/messages/vi.json`, khoá `nhatKy.cauHinh`), đổi phần nói
 * về "quản trị tenant" sang Platform Admin / Auditor.
 */
export const viGiaAi = {
  giaAi: {
    tabBangGia: 'Giá vốn',
    tabTyGia: 'Tỷ giá',
    // Cột Người tạo: dòng của chính người đang xem (nếp màn License).
    ban: 'Bạn',

    loaiToken: {
      dau_vao: 'Token vào',
      dau_vao_anh: 'Token ảnh vào',
      dau_vao_tool: 'Token công cụ vào',
      dau_vao_dem: 'Token đọc từ bộ nhớ đệm',
      ghi_dem: 'Token ghi vào bộ nhớ đệm',
      dau_ra: 'Token ra',
      suy_luan: 'Token suy luận',
    },
    loaiTokenNgan: {
      dau_vao: 'Vào',
      dau_vao_anh: 'Ảnh',
      dau_vao_tool: 'Công cụ',
      dau_vao_dem: 'Đọc đệm',
      ghi_dem: 'Ghi đệm',
      dau_ra: 'Ra',
      suy_luan: 'Suy luận',
    },

    hieuLuc: {
      chuaToi: 'Chưa tới hiệu lực',
      chuaToiMo: 'Dòng này có hiệu lực trong tương lai, chưa dùng để tính giá vốn lượt gọi nào, và sẽ đóng dòng đang hiệu lực đúng tại mốc đó.',
      dangApDung: 'Đang áp dụng',
      daDong: 'Đã đóng',
      biThay: 'Bị thay thế',
      biThayMo: 'Một dòng khác nhập sau, cùng mốc hiệu lực, đã thay thế dòng này. Dòng này không dùng để tính giá vốn lượt gọi nào.',
    },

    bang: {
      chonCheDo: 'Chọn cách xem',
      dangHieuLuc: 'Đang hiệu lực',
      lichSu: 'Lịch sử giá',
      locMoHinh: 'Lọc theo tên mô hình',
      locMoHinhGoiY: 'Tên mô hình thật, nhấn Enter',
      locMoHinhMo: 'Nhập tên mô hình thật (ví dụ gemini-2.5-pro) để xem những dòng giá có mẫu khớp với nó.',
      themDongGia: 'Thêm dòng giá',
      giaiThichVon: 'Giá nhà cung cấp tính cho nền tảng. Tenant không thấy bảng này.',
      khongSuaDe: 'Giá đã lưu không sửa được: để đổi giá, thêm một dòng mới có mốc hiệu lực; dòng cũ tự đóng tại mốc đó.',
      chiXem: 'Bạn chỉ xem được giá vốn. Chỉ Platform Admin thêm được dòng giá.',
      captionVon: 'Giá vốn của nền tảng',
      cotMoHinh: 'Mẫu mô hình',
      cotDonVi: 'Đơn vị',
      cotHieuLucTu: 'Hiệu lực từ',
      cotHieuLucDen: 'Hiệu lực đến',
      cotNguoiTao: 'Người tạo',
      cotLyDo: 'Lý do đổi giá',
      moiTinhNang: 'Mọi tính năng',
      bacGia: 'Bậc giá từ {{so}} token vào',
      donViRutGon: '{{tien}} / {{so}} token',
      conMo: 'Còn mở',
      giaMuon: '(= giá {{tu}})',
      giaMuonMo: 'Không khai giá riêng: lượt gọi tính theo giá {{tu}}.',
      giaKhongKhai: 'Không khai giá và không có giá nào để mượn.',
      doiGia: 'Đổi giá',
      doiGiaCua: 'Đổi giá của {{mau}}',
      loiTai: 'Chưa tải được giá vốn. {{loi}}',
      rongThat: 'Chưa có dòng giá nào',
      rongThatMo: 'Lượt gọi mô hình chưa có giá vốn được ghi là chưa có giá. Thêm dòng giá đầu tiên cho mô hình đang dùng.',
      rongThatChiXem: 'Lượt gọi mô hình chưa có giá vốn được ghi là chưa có giá. Chỉ Platform Admin thêm được dòng giá.',
      rongHieuLuc: 'Không còn dòng giá nào đang hoặc sắp hiệu lực',
      rongLocMoHinh: 'Không có dòng giá nào khớp với {{mo_hinh}}',
      dangHien: 'Đang hiện {{so}} dòng',
      dangHienHieuLuc: 'Đang hiện {{so}} dòng đang hoặc sắp hiệu lực, trong {{tong}} dòng của lịch sử',
    },

    form: {
      tieuDeThemVon: 'Thêm dòng giá vốn',
      tieuDeDoiVon: 'Đổi giá vốn: thêm phiên bản mới',
      khongSuaDe: 'Giá đã lưu không sửa được. Đổi giá là thêm dòng mới với mốc hiệu lực.',
      nhomMoHinh: 'Mô hình và hiệu lực',
      moHinh: 'Model',
      chonMoHinh: 'Tìm theo tên hoặc tên model thật',
      khongCoModel: 'Không có model nào khớp',
      danhMucRong: 'Danh mục Model AI chưa có model',
      chuaCoTenThat: 'Chưa có tên model thật — đặt ở màn Model AI',
      loiDanhMuc: 'Không tải được danh mục Model AI: {{loi}}',
      nhapMau: 'Nhập mẫu cho cả họ mô hình',
      chonTuDanhMuc: 'Chọn từ danh mục Model AI',
      mauMoHinh: 'Mẫu tên mô hình',
      mauMoHinhGoiY: 'qwen2.5-7b*',
      nhaCungCap: 'Nhà cung cấp',
      nhaCungCapGoiY: 'Chọn nhà cung cấp',
      theoModel: 'Theo model đã chọn',
      donViTien: 'Đơn vị tiền',
      hieuLucTu: 'Hiệu lực từ',
      nhomGia: 'Đơn giá',
      donGiaTren: 'Giá cho mỗi {{so}} token, tính bằng {{tien}}.',
      oTrongAnGia: 'Trống = giá {{tu}}',
      lyDo: 'Lý do đổi giá',
      nangCao: 'Tuỳ chọn nâng cao',
      donViToken: 'Giá tính trên bao nhiêu token',
      tinhNang: 'Tính năng',
      nguongDauVao: 'Ngưỡng token vào',
      khongChiaBac: 'Không chia bậc',
      oGiaGiuNguyen: 'Mẫu mô hình, tính năng và bậc giữ nguyên khi đổi giá.',
      xemLaiRoiLuu: 'Xem lại rồi lưu',
      xacNhanVon: 'Thêm dòng giá vốn cho {{mau}}?',
      xacNhanThan: 'Dòng giá có hiệu lực từ {{moc}}. Dòng đang hiệu lực của cùng ô giá tự đóng tại mốc đó. Không hoàn tác được: chỉ thêm được, không sửa hay xoá được dòng đã thêm; nhập sai thì thêm một dòng đúng.',
      daThem: 'Đã thêm dòng giá cho {{mau}}.',
      loiTrong: 'Trường này không được để trống.',
      loiQuaDai: 'Tối đa {{so}} ký tự.',
      loiGiaSai: 'Chỉ nhập số không âm, tối đa sáu chữ số thập phân.',
      loiSoNguyen: 'Nhập một số nguyên dương, ví dụ 1000000.',
      loiThieuMoc: 'Chọn mốc hiệu lực.',
      loiMocQuaKhu: 'Mốc hiệu lực không được lùi về quá khứ. Chọn một mốc từ bây giờ trở đi.',
      loiThieuGia: 'Nhập giá cho ít nhất một loại token, thường là Token vào và Token ra.',
      loiChonModel: 'Chọn một model.',
      loiChonNhaCungCap: 'Chọn nhà cung cấp.',
      loiDonViTien: 'Chọn đơn vị tiền.',
      loiTheoO: 'Máy chủ từ chối vài ô. Sửa các ô có lỗi bên trên rồi lưu lại.',
    },

    tyGia: {
      moTa: 'Tỷ giá theo ngày, dùng để quy đổi giá vốn khai bằng ngoại tệ về đơn vị tiền của báo cáo.',
      khongSuaDe:
        'Bảng tỷ giá chỉ cho thêm: dòng mới đóng dòng trước của cùng chiều quy đổi, không có chức năng sửa. Tỷ giá ghi nhận theo ngày, không theo giờ.',
      chiXem: 'Bạn chỉ xem được tỷ giá. Chỉ Platform Admin thêm được dòng tỷ giá.',
      themTyGia: 'Thêm tỷ giá',
      doiTyGia: 'Đổi tỷ giá',
      doiTyGiaCua: 'Đổi tỷ giá {{tu}} sang {{den}}',
      caption: 'Tỷ giá theo chiều quy đổi',
      cotChieu: 'Chiều quy đổi',
      soPhienBan: '{{so}} phiên bản',
      phienBanCu: 'Phiên bản trước',
      tyGia: 'Tỷ giá',
      tyGiaGoiY: '25400',
      tyGiaMo: 'Một {{tu}} bằng bao nhiêu {{den}}. Phải lớn hơn 0, tối đa sáu chữ số thập phân.',
      hieuLucTuNgay: 'Hiệu lực từ ngày',
      hieuLucTuNgayMo: 'Dòng đang áp dụng của cùng chiều sẽ đóng đúng vào ngày này.',
      denNgay: 'Hiệu lực đến ngày',
      donViGoc: 'Đơn vị gốc',
      donViDich: 'Đơn vị đích',
      lyDo: 'Nguồn hoặc lý do',
      lyDoMo: 'Nguồn tỷ giá, hoặc lý do thay đổi. Hiện trong bảng.',
      loiTai: 'Chưa tải được bảng tỷ giá. {{loi}}',
      loiTyGia: 'Tỷ giá phải là một số lớn hơn 0, tối đa sáu chữ số thập phân.',
      loiCungDonVi: 'Đơn vị đích phải khác đơn vị gốc.',
      loiThieuNgay: 'Chọn ngày hiệu lực.',
      daThem: 'Đã thêm tỷ giá {{tu}} sang {{den}}.',
      xacNhanQuaKhuTieuDe: 'Thêm tỷ giá {{tu}} sang {{den}} có hiệu lực từ {{ngay}}, một ngày đã qua?',
      xacNhanQuaKhuThan: 'Giá vốn đã ghi cho các lượt gọi từ {{ngay}} không đổi theo tỷ giá mới. Thêm rồi thì không sửa, không xoá được; nhập sai thì thêm một dòng đúng.',
      xacNhanQuaKhuNut: 'Thêm tỷ giá từ {{ngay}}',
      rongThat: 'Chưa có dòng tỷ giá nào',
      rongThatMo: 'Chưa cần tỷ giá nếu mọi dòng giá vốn đều khai bằng đơn vị tiền của báo cáo. Thêm tỷ giá khi có mô hình khai giá bằng ngoại tệ.',
      rongThatChiXem: 'Chưa cần tỷ giá nếu mọi dòng giá vốn đều khai bằng đơn vị tiền của báo cáo. Chỉ Platform Admin thêm được dòng tỷ giá.',
    },
  },
};
